module.exports = __webpack_public_path__ + "static/media/air-conditioner.26398ab0.svg";